import { Boundaries } from "@planzone/core";
import { events } from "@planzone/events";
import { setRequestStateToPending } from "../../utils/setRequestStateToPending";
import { setRequestStateToSuccess } from "../../utils/setRequestStateToSuccess";
import { setRequestStateToFailure } from "../../utils/setRequestStateToFailure";
import { createStateReducer } from "../../utils/createStateReducer";
import { resetState } from "../../utils/resetState";
import { State, Selector } from "./types";
import { createSelector } from "./selector";
import { removeEventError } from "@planzone/dto";

const initialState: State = [];

function handleRequest(
  state: State,
  event: Boundaries["removeEvent"]["request"],
): State {
  return [
    ...state,
    { event, request: setRequestStateToPending(), error: removeEventError },
  ];
}

function handleSuccess(
  state: State,
  event: Boundaries["removeEvent"]["success"],
): State {
  return state.map((item) =>
    item.event.uuid === event.uuid
      ? { event, request: setRequestStateToSuccess(), error: removeEventError }
      : item,
  );
}

function handleFailure(
  state: State,
  { event, error }: Boundaries["removeEvent"]["failure"],
): State {
  return state.map((item) =>
    item.event.uuid === event.uuid
      ? { event, request: setRequestStateToFailure(), error }
      : item,
  );
}

const reduceState = resetState(
  initialState,
  createStateReducer(initialState, {
    [events.removeEventRequested]: handleRequest,
    [events.removeEventSucceeded]: handleSuccess,
    [events.removeEventFailed]: handleFailure,
  }),
  [events.changePlanzoneSucceeded],
);

export type { State, Selector };

export { reduceState, initialState, createSelector };
